export const BLOOD_GROUP = [
  { name: 'A+' },
  { name: 'B+' },
  { name: 'AB+' },
  { name: 'O+' },
  { name: 'A-' },
  { name: 'B-' },
  { name: 'AB-' },
  { name: 'O-' },
];
